export default {
  selectable: false,
  slideContainer: true,
  skipInQuickEditPanel: true,
};
